import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class UserIdInterceptor implements HttpInterceptor {

  constructor(private cookieService: CookieService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Obtener el token JWT desde las cookies
    const token = this.cookieService.get('X-Access-Token');
    
    // Obtener el userId desde localStorage
    const userId = localStorage.getItem('currentUserId');
    
    // Preparar headers
    const headers: { [key: string]: string } = {};
    
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    
    if (userId) {
      headers['X-User-Id'] = userId;
    }
    
    // Clonar la request y agregar los headers
    const modifiedRequest = request.clone({
      setHeaders: headers
    });
    
    return next.handle(modifiedRequest);
  }
} 